import {
    SPE_PURCHASE_ORDER,
    SPE_PURCHASE_ORDER_SUCCESS,
    SPE_PURCHASE_ORDER_ERROR,
    SPE_SUPPLIER,
    SPE_SUPPLIER_SUCCESS,
    SPE_SUPPLIER_ERROR,
    SPE_CATEGORY,
    SPE_CATEGORY_SUCCESS,
    SPE_CATEGORY_ERROR,
    SPE_PURCHASE_ORDER_STATUS,
    SPE_PURCHASE_ORDER_STATUS_SUCCESS,
    SPE_PURCHASE_ORDER_STATUS_ERROR,
    SPE_USER_ROLE,
    SPE_USER_ROLE_SUCCESS,
    SPE_USER_ROLE_ERROR,
    PO_SPE_LIST,
    PO_SPE_LIST_SUCCESS,
    PO_SPE_LIST_ERROR,
    PO_SPE_LIST_SEARCH_CHANGE,
    PO_SPE_LIST_PAGE_SET,
    SPE_ADD_COMITE_MODAL_SET,
    SPE_ADD_COMITE_CHANGE_SET,
    SPE_ADD_COMITE,
    SPE_ADD_COMITE_SUCCESS,
    SPE_ADD_COMITE_ERROR,
    SPE_ADD_EVALUATION_MODAL_SET,
    SPE_CHECKLIST,
    SPE_CHECKLIST_SUCCESS,
    SPE_CHECKLIST_ERROR,
    SPE_EVALUATION_OPTION,
    SPE_EVALUATION_OPTION_SUCCESS,
    SPE_EVALUATION_OPTION_ERROR,
    SPE_ADD_EVALUATION_CHANGE_SET,
    SPE_ADD_EVALUATION,
    SPE_ADD_EVALUATION_SUCCESS,
    SPE_ADD_EVALUATION_ERROR,
    SPE_CLOSED_EVALUATION_MODAL_SET,
    SPE_CLOSED_EVALUATION_CHANGE_SET,
    SPE_CLOSED_EVALUATION,
    SPE_CLOSED_EVALUATION_SUCCESS,
    SPE_CLOSED_EVALUATION_ERROR,
    SPE_DOWNLOAD_EVALUATION_MODAL_SET,
    SPE_DOWNLOAD_EVALUATION_CHANGE_SET,
    SPE_CHECKLIST_SCORE,
    SPE_CHECKLIST_SCORE_SUCCESS,
    SPE_CHECKLIST_SCORE_ERROR,
    SPE_EDIT_COMITE_MODAL_SET,
    SPE_EDIT_COMITE_CHANGE_SET,
    SPE_EDIT_COMITE,
    SPE_EDIT_COMITE_SUCCESS,
    SPE_EDIT_COMITE_ERROR,
} from "../actions";

const INIT_STATE = {
    loading: false,
    list: {
        page: {
            current: 1,
            rows: 10
        }
    },
    purchaseorder: {
        loading: false,
        data: []
    },
    supplier: {
        loading: false,
        data: []
    },
    category: {
        loading: false,
        data: []
    },
    purchaseorderstatus: {
        loading: false,
        data: []
    },
    userrole: {
        loading: false,
        data: []
    },
    checklist: {
        loading: false,
        data: []
    },
    evaluationoption: {
        loading: false,
        data: []
    },
    score: {
        loading: false,
        data: []
    },
    addcomite: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    addevaluation: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    closedevaluation: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    downloadevaluation: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    editcomite: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
     error: false,
    search: {
        modal: false,
        init: true,
        data: {
            purchaseorder: '',
            supplier: '',
            category: '',
            purchaseorderstatus: '',
            status:''
        },
        value: {
            purchaseorder: '',
            supplier: '',
            category: '',
            purchaseorderstatus: '',
            status:''
        }
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case SPE_PURCHASE_ORDER:
            return {
                ...state,
                loading: true,
                purchaseorder: {
                    ...state.purchaseorder
                }
            }
        case SPE_PURCHASE_ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                purchaseorder: {
                    ...state.purchaseorder,
                    ...action.payload
                }
            }
        case SPE_PURCHASE_ORDER_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case SPE_SUPPLIER:
            return {
                ...state,
                loading: true,
                supplier: {
                    ...state.supplier
                }
            }
        case SPE_SUPPLIER_SUCCESS:
            return {
                ...state,
                loading: false,
                supplier: {
                    ...state.supplier,
                    ...action.payload
                }
            }
        case SPE_SUPPLIER_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case SPE_CATEGORY:
            return {
                ...state,
                loading: true,
                category: {
                    ...state.category
                }
            }
        case SPE_CATEGORY_SUCCESS:
            return {
                ...state,
                loading: false,
                category: {
                    ...state.category,
                    ...action.payload
                }
            }
        case SPE_CATEGORY_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case PO_SPE_LIST:
            return {
                ...state,
                loading: true,
                list: {
                    ...state.list
                }
            }
        case SPE_PURCHASE_ORDER_STATUS:
            return {
                ...state,
                loading: true,
                purchaseorderstatus: {
                    ...state.purchaseorderstatus
                }
            }
        case SPE_PURCHASE_ORDER_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                purchaseorderstatus: {
                    ...state.purchaseorderstatus,
                    ...action.payload
                }
            }
        case SPE_PURCHASE_ORDER_STATUS_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case SPE_USER_ROLE:
            return {
                ...state,
                loading: true,
                userrole: {
                    ...state.userrole
                }
            }
        case SPE_USER_ROLE_SUCCESS:
            return {
                ...state,
                loading: false,
                userrole: {
                    ...state.userrole,
                    ...action.payload
                }
            }
        case SPE_USER_ROLE_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case SPE_EVALUATION_OPTION:
            return {
                ...state,
                loading: true,
                evaluationoption: {
                    ...state.evaluationoption
                }
            }
        case SPE_EVALUATION_OPTION_SUCCESS:
            return {
                ...state,
                loading: false,
                evaluationoption: {
                    ...state.evaluationoption,
                    ...action.payload
                }
            }
        case SPE_EVALUATION_OPTION_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case PO_SPE_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case PO_SPE_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }

        case PO_SPE_LIST_PAGE_SET:
            return {
                ...state,
                list: {
                    ...state.list,
                    page: {
                        ...state.list.page,
                        ...action.payload,
                    }
                }
            }
        case PO_SPE_LIST_SEARCH_CHANGE:
            return {
                ...state,
                search: {
                    ...state.search,
                    data: action.payload,
                }
            }
        case SPE_ADD_COMITE_MODAL_SET:
            return {
                ...state,
                addcomite: {
                    ...state.addcomite,
                    modal: action.payload
                }
            }
        case SPE_ADD_COMITE_CHANGE_SET:
            return {
                ...state,
                addcomite: {
                    ...state.addcomite,
                    data: {
                        ...state.addcomite.data,
                        ...action.payload
                    }
                }
            }
        case SPE_ADD_COMITE:
            return {
                ...state,
                addcomite: {
                    ...state.addcomite,
                    loading: false
                }
            }
        case SPE_ADD_COMITE_SUCCESS:
            return {
                ...state,
                addcomite: {
                    ...state.addcomite,
                    modal: false,
                    loading: false,
                    url: action.payload.url,
                    type: action.payload.type,
                    message: action.payload.message
                },
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case SPE_ADD_COMITE_ERROR:
            return {
                ...state,
                addcomite: {
                    ...state.addcomite,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        case SPE_ADD_EVALUATION_MODAL_SET:
            return {
                ...state,
                addevaluation: {
                    ...state.addevaluation,
                    modal: action.payload
                }
            }
        case SPE_CHECKLIST:
            return {
                ...state,
                loading: true,
                checklist: {
                    ...state.checklist
                }
            }
        case SPE_CHECKLIST_SUCCESS:
            return {
                ...state,
                loading: false,
                checklist: {
                    ...state.checklist,
                    ...action.payload
                }
            }
        case SPE_CHECKLIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case SPE_ADD_EVALUATION_CHANGE_SET:
            return {
                ...state,
                addevaluation: {
                    ...state.addevaluation,
                    data: {
                        ...state.addevaluation.data,
                        ...action.payload
                    }
                }
            }
        case SPE_ADD_EVALUATION:
            return {
                ...state,
                addevaluation: {
                    ...state.addevaluation,
                    loading: false
                }
            }
        case SPE_ADD_EVALUATION_SUCCESS:
            return {
                ...state,
                addevaluation: {
                    ...state.addevaluation,
                    modal: false,
                    loading: false,
                    url: action.payload.url,
                    type: action.payload.type,
                    message: action.payload.message
                },
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case SPE_ADD_EVALUATION_ERROR:
            return {
                ...state,
                addevaluation: {
                    ...state.addevaluation,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        case SPE_CLOSED_EVALUATION_MODAL_SET:
            return {
                ...state,
                closedevaluation: {
                    ...state.closedevaluation,
                    modal: action.payload
                }
            }
        case SPE_CLOSED_EVALUATION_CHANGE_SET:
            return {
                ...state,
                closedevaluation: {
                    ...state.closedevaluation,
                    data: {
                        ...state.closedevaluation.data,
                        ...action.payload
                    }
                }
            }
        case SPE_CLOSED_EVALUATION:
            return {
                ...state,
                closedevaluation: {
                    ...state.closedevaluation,
                    loading: false
                }
            }
        case SPE_CLOSED_EVALUATION_SUCCESS:
            return {
                ...state,
                closedevaluation: {
                    ...state.closedevaluation,
                    modal: false,
                    loading: false,
                    url: action.payload.url,
                    type: action.payload.type,
                    message: action.payload.message
                },
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case SPE_CLOSED_EVALUATION_ERROR:
            return {
                ...state,
                closedevaluation: {
                    ...state.closedevaluation,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        case SPE_DOWNLOAD_EVALUATION_MODAL_SET:
            return {
                ...state,
                downloadevaluation: {
                    ...state.downloadevaluation,
                    modal: action.payload
                }
            }
        case SPE_DOWNLOAD_EVALUATION_CHANGE_SET:
            return {
                ...state,
                downloadevaluation: {
                    ...state.downloadevaluation,
                    data: {
                        ...state.downloadevaluation.data,
                        ...action.payload
                    }
                }
            }
        case SPE_CHECKLIST_SCORE:
            return {
                ...state,
                loading: true,
                score: {
                    ...state.score
                }
            }
        case SPE_CHECKLIST_SCORE_SUCCESS:
            return {
                ...state,
                loading: false,
                score: {
                    ...state.score,
                    ...action.payload
                }
            }
        case SPE_CHECKLIST_SCORE_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case SPE_EDIT_COMITE_MODAL_SET:
            return {
                ...state,
                editcomite: {
                    ...state.editcomite,
                    modal: action.payload
                }
            }
        case SPE_EDIT_COMITE_CHANGE_SET:
            return {
                ...state,
                editcomite: {
                    ...state.editcomite,
                    data: {
                        ...state.editcomite.data,
                        ...action.payload
                    }
                }
            }
        case SPE_EDIT_COMITE:
            return {
                ...state,
                editcomite: {
                    ...state.editcomite,
                    loading: false
                }
            }
        case SPE_EDIT_COMITE_SUCCESS:
            return {
                ...state,
                editcomite: {
                    ...state.editcomite,
                    modal: false,
                    loading: false,
                    url: action.payload.url,
                    type: action.payload.type,
                    message: action.payload.message
                },
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case SPE_EDIT_COMITE_ERROR:
            return {
                ...state,
                editcomite: {
                    ...state.editcomite,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }

    default:
        return { ...state };
    }
};